import { combineReducers } from 'redux';

import { communication } from './communication';
import { data } from './data';
import * as TS from '../../types';

export const reducer = combineReducers<TS.ReduxState>({ communication, data });
